// ================= Home Part ==================== //
export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';
export const RESET = 'RESET';
export const ADD_TO_NUMBER = 'ADD_TO_NUMBER';

// ================= User Part ==================== //

export const FETCH_USER_LIST = 'FETCH_USER_LIST';
export const FETCH_USER_LIST_FAIL = 'FETCH_USER_LIST_FAIL';
export const FETCH_USER_LIST_SUCCESS = 'FETCH_USER_LIST_SUCCESS';